import { LogLevel, PublicClientApplication, type Configuration } from "@azure/msal-browser";
import { config } from "../config";

// Escopo delegado exposto pelo registro da API AVA Remota.
export const API_SCOPES = config.externalId.apiScope
  ? [config.externalId.apiScope]
  : ["openid", "profile", "email"];

// Solicita o acesso à API já no primeiro redirect. Assim o token devolvido ao
// Portal pertence à AVA Remota API, evitando um segundo redirect logo após o
// login e impedindo que um token de outro recurso chegue ao backend.
export const LOGIN_SCOPES = ["openid", "profile", "email", ...API_SCOPES];

const msalConfiguration: Configuration = {
  auth: {
    clientId: config.externalId.clientId,
    authority: config.externalId.authority,
    knownAuthorities: config.externalId.knownAuthority ? [config.externalId.knownAuthority] : [],
    redirectUri: config.externalId.redirectUri,
    postLogoutRedirectUri: config.externalId.redirectUri,
  },
  cache: {
    // Sessão apenas: nada de token em armazenamento persistente.
    cacheLocation: "sessionStorage",
  },
  system: {
    loggerOptions: {
      // MSAL nunca deve escrever PII/tokens no console.
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
  },
};

export function createMsalInstance(): PublicClientApplication {
  return new PublicClientApplication(msalConfiguration);
}
